module.exports = __webpack_public_path__ + "static/media/btdx.a8988aa0.svg";